import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-bullet-alert",
  "use": "arrow-bullet-alert-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"arrow-bullet-alert\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <g fill=\"#F75757\">\n            <g>\n                <g>\n                    <g>\n                        <path d=\"M6 4L8 4 12 9 8 14 6 14 10 9z\" transform=\"translate(-903 -392) translate(879 154) translate(24 236) translate(0 2)\" />\n                    </g>\n                </g>\n            </g>\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol